export const isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
export const allowFunction = true; // allow user to create functions
export const allowAgent = true; // (environment !== 'production') allow user to create agents in non-production environments
